const plusSVG = `
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.0315 6.752H7.13552V11.912H5.39552V6.752H0.523523V5.132H5.39552V0.0079999H7.13552V5.132H12.0315V6.752Z" fill="#241247"/>
    </svg>
`

export default plusSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/plusSVG.js